import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { UserBasicInfo } from "../model/user/UserBasicInfo";
import { environment } from '../../../environments/environment';
import { HttpHelperService } from './httphelper.service';
import { ErrorService } from './error.service';
import { UserSessionService } from './user-session.service';
import { Observable } from 'rxjs';

const API_URL = environment.apiUrl;
// const AUTH_API_URL = `${API_URL}auth/`;
const AUTH_API_URL = `${API_URL}v2/auth/`;

// Where Keycloak sends the browser back to once the OIDC round trip completes.
const LOGIN_CALLBACK_PATH = '/#/authentication/login-callback';

@Injectable()
export class AuthService {
	constructor(
		public router: Router,
		private http: HttpClient,
		private httpHelperService: HttpHelperService,
		private userSessionService: UserSessionService
	) { }

	// Keycloak hosts the login page (email, password and the KOMBIT/NemLog-in button), so every
	// unauthenticated entry point funnels through here.
	redirectToLogin(callbackUrl?: string, careHomeId?: string): void {
		// Drop any stale local session before handing off. clearUserSession deliberately keeps
		// 'language' and 'last_used_carehome', both of which are read below.
		this.userSessionService.clearUserSession();

		const returnUrl = callbackUrl || `${window.location.origin}${LOGIN_CALLBACK_PATH}`;
		const language = this.userSessionService.getLanguage();
		const targetCareHome = careHomeId || this.userSessionService.getLastUsedCareHome();

		let url = `${AUTH_API_URL}login?returnUrl=${encodeURIComponent(returnUrl)}&lang=${encodeURIComponent(language)}`;
		if (targetCareHome) {
			url += `&careHomeId=${encodeURIComponent(targetCareHome)}`;
		}
		window.location.href = url;
	}

	getLogoutUrl(): string {
		const language = this.userSessionService.getLanguage();
		return `${AUTH_API_URL}logout?lang=${encodeURIComponent(language)}`;
	}

	VerifyCode(code: string): Observable<HttpResponse<UserBasicInfo>> {
		return this.http.post<UserBasicInfo>(`${AUTH_API_URL}VerifyCode?code=${code}`, {}, this.httpHelperService.getHttpOptions());
	}

	resendOtp() {
		return this.http.post<boolean>(`${AUTH_API_URL}resendotp`, null, this.httpHelperService.getHttpOptions());
	}

	verifyEmail(email: string) {
		return this.http.post(`${AUTH_API_URL}verifyemail?email=${email}`, this.httpHelperService.getHttpOptions());
	}

	validateResetPasswordToken(token: string) {
		return this.http.post<boolean>(`${AUTH_API_URL}validateresettoken/${token}`, this.httpHelperService.getHttpOptions());
	}

	resetPassword(token: string, password: string) {
		console.log(password);
		return this.http.post<boolean>(`${AUTH_API_URL}resetpassword`, { password: password, token: token }, this.httpHelperService.getHttpOptions());
	}

	isAuthenticated(): Observable<HttpResponse<{ username: string, id: string }>> {
		return this.http.get<{ username: string, id: string }>(`${AUTH_API_URL}isAuthenticated`, this.httpHelperService.getHttpOptions());
	}

	getCurrentUser(): Observable<HttpResponse<UserBasicInfo>> {
		return this.http.get<UserBasicInfo>(`${AUTH_API_URL}current-user`, this.httpHelperService.getHttpOptions());
	}

	switchCarehome(careHomeId: string | null): Observable<HttpResponse<UserBasicInfo>> {
		return this.http.post<any>(`${AUTH_API_URL}switch-carehome`, { careHomeId }, this.httpHelperService.getHttpOptions());
	}

	signOutOtherSessions(): Observable<HttpResponse<any>> {
		return this.http.post<any>(`${AUTH_API_URL}sign-out-other-sessions`, {}, this.httpHelperService.getHttpOptions());
	}
}